module.exports = __webpack_public_path__ + "img/linetop1.13276d51.png";